<template>
  <div class="icon">
    <workfolder-icon v-if="type === 'workfolder'"></workfolder-icon>
    <videotrack-icon v-else-if="type === 'videotrack'"></videotrack-icon>
    <track-icon v-else-if="type === 'track'"></track-icon>
    <route-icon v-else-if="type === 'route'"></route-icon>
    <poi-icon v-else-if="type === 'poi'"></poi-icon>
  </div>
</template>

<style scoped>
.icon {
  display: flex;
}
.icon svg {
  height: 24px;
}
</style>


<script>
import WorkfolderIcon from '@/components/shared/icons/Workfolder'
import VideotrackIcon from '@/components/shared/icons/Videotrack'
import TrackIcon from '@/components/shared/icons/Track'
import RouteIcon from '@/components/shared/icons/Route'
import PoiIcon from '@/components/shared/icons/Poi'

export default {
  props: ['type'],
  components: {
    WorkfolderIcon,
    VideotrackIcon,
    TrackIcon,
    RouteIcon,
    PoiIcon
  }
}
</script>




// WEBPACK FOOTER //
// src/components/suggestions/DataIcon.vue